let sizeInput = document.querySelector('#option-size');

// This is a janky fix for other quirks of not selecting the first variant / sizes qualified as out of stock.
// Possibly update URLs in collection so page doesn't load twice
/*
let url = window.location.href;
let variantId = sizeInput
.querySelector('.swatch-element')
.getAttribute('data-id');
if (!url.includes('variant=')) {
  url.includes('?')
  ? (url += `&variant=${variantId}`)
  : (url += `?variant=${variantId}`);
  window.location.href = url;
}
*/

// Use element clicks to update variant
let url = window.location.href;
let firstAvailableId = document
  .querySelector('#option-size')
  .querySelector('input[checked]')
  .getAttribute('variant-id');
document
  .querySelector('.product_form_options')
  .querySelector('form')
  .querySelector('.getSelectedId')
  .setAttribute('value', firstAvailableId);

console.log('First UNIFIED variant selected - ID:', firstAvailableId);

function selectFirstAddon(productId) {
  console.log('Form Product ID: ', productId);
  const id = `#product_form_${productId}`;
  const form = document.querySelector(id);
  const firstAvailable = form
    .querySelector('#option-size')
    .querySelector('input[checked]')
    .getAttribute('variant-id');

  form.querySelector('.getSelectedId').setAttribute('value', firstAvailable);
}
